import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';

import Stepper from 'react-stepper-horizontal';

import * as ProjectActionType from 'Projects/constants';

import emptyImages from 'assets/img/empty-images.svg';
import emptyFolderIcon from 'assets/img/folder.png';

import './inventory.css';

export class ImportInventory extends React.Component {
  static propTypes = {
    itemArray: PropTypes.array,
    projectId: PropTypes.string,
    exposeRef: PropTypes.func,
    hasSelected: PropTypes.func,
    dispatch: PropTypes.func,
    breadcrumbsHistory: PropTypes.string,
    goBack: PropTypes.func
  }

  constructor(props) {
    super(props);

    this.state = {
      checkedItemArray: [],
      hideItems: [],
      steps: [{
        title: 'Import inventory',
        onClick: (e) => {
          e.preventDefault();
        }
      }, {
        title: 'Import inventory items',
        onClick: (e) => {
          e.preventDefault();
        }
      }],
      currentStep: 0,
      searchText: ''
    };

    this.props.exposeRef(this);

    this.breadcrumbs = [
      { title: 'Inventory', url: '/', onCustomAction: this.props.goBack },
      { title: 'Import inventory', url: '' }
    ];
  }

  componentDidMount() {
    this.getTemplateList();
    this.props.hasSelected(this.state.checkedItemArray.length > 0);
  }

  //#region Event Handler
  onCheckInventoryTemplate(templateId, templateName) {
    let index = this.state.checkedItemArray.findIndex(i => {
      console.log(i);
      return i[0] === templateId;
    });

    let newArray = [...this.state.checkedItemArray];

    if (index !== -1) {
      newArray.splice(index, 1);
    }
    else {
      newArray.push([templateId, templateName]);
    }

    this.setState({ ...this.state, checkedItemArray: newArray },
      () => {
        this.props.hasSelected(this.state.checkedItemArray.length > 0);
      });

  }

  //#endregion Event Handler

  getTemplateList() {
    this.props.dispatch({
      type: ProjectActionType.GET_INVENTORY_TEMPLATE_LIST_ASYNC,
      params: {
        projectId: this.props.projectId
      }
    });
  }

  onSearch() {
    let items = [];

    this.props.itemArray.map((e) => {
      if (!e.name.toLowerCase().includes(this.state.searchText.toLowerCase())) {
        items.push(e.id);
      }
    });

    this.setState({hideItems: items});
  }

  submit(callback) {
    if (this.state.checkedItemArray.length > 0) {
      let selected = this.state.checkedItemArray.map((value) => {
        return value[0];
      });

      this.props.dispatch({
        type: ProjectActionType.POST_INVENTORY_TEMPLATE_LIST_ASYNC,
        params: {
          projectId: this.props.projectId,
          CategoryTemplateIds: selected
        },
        callback
      });
    }
    else {
      callback();
    }
  }

  //#region Render
  renderToolTipForCheckbox(isShowTooltip) {
    if (isShowTooltip) {
      return (
        <Tooltip id='sign_off_multiple_work_order_tooltip' className='in tooltip-siteone'>
          <span>This inventory is already added to current project</span>
        </Tooltip>
      );
    }

    return '';
  }

  renderCheckbox(e) {
    if (e.isExist) {
      return (
        <OverlayTrigger placement='top' overlay={this.renderToolTipForCheckbox(e.isExist)}>
          <div>
            <CheckBoxSingle
              value={e.id}
              disableClick={e.isExist}
              checked={false}
              style={e.isExist ? { opacity: '0.5', color: '#777' } : null}
            />
          </div>
        </OverlayTrigger>
      );
    }

    return (
      <CheckBoxSingle
        value={e.id}
        disableClick={e.isExist}
        checked={this.state.checkedItemArray.findIndex(i => { return i[0] === e.id; }) > -1}
        onChecked={() => this.onCheckInventoryTemplate(e.id, e.name)}
        style={e.isExist ? { opacity: '0.5', color: '#777' } : null} />
    );
  }

  renderItemList() {
    if ((Array.isArray(this.props.itemArray) && this.props.itemArray.length > 0)) {
      return (
        // this.props.itemArray.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map(e => {
        this.props.itemArray.sort((a, b) => a.name.localeCompare(b.name)).map(e => {
          return (
            this.state.hideItems.indexOf(e.id) === -1 &&
            <React.Fragment>
              <div key={e.id} style={{ marginBottom: 15 }} className='col-md-3 col-xs-6 col-sm-6 col-lg-3'>
                <div className='category-list-items'>
                  <div className='category-list-item-wrapper'>
                    <img style={{ width: '100%', height: 170, objectFit: 'contain' }} src={e.image ? e.image.thumbnailUrl : emptyImages} />
                  </div>
                  <div className='category-list-items-project-name'>
                    <div className='category-name col-md-8 col-sm-8'>
                      <span>{e.name}</span>
                    </div>
                    <div className='category-name col-md-4 col-sm-4' style={{ textAlign: 'right' }}>
                      {this.renderCheckbox(e)}
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        }));
    }
    else
    {
      return (
        <div style={{textAlign: 'center'}}>
          <img src={emptyFolderIcon} alt='no-files'/>
          <p style={{marginTop: '10px'}}>No files</p>
        </div>
      );
    }
  }

  render() {
    const { steps, currentStep } = this.state;

    return (
      <React.Fragment>
        <h4 style={{ height: 30, marginTop: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>Import from Library</h4>
        <div className='row'>
          <div className='col-md-4 col-lg-4 col-sm-6'>
            <Breadcrumb breadcrumbs={this.breadcrumbs} />
          </div>
          <div className='col-md-offset-4 col-md-4 col-lg-4 col-sm-6 float-right'>
            <div className='box-search' style={{ margin: 0, transform: 'translateY(5px)' }}>
              <div className='input-group'>
                <input
                  type='text'
                  id='txt-search-email'
                  value={this.state.searchText}
                  className='form-control'
                  placeholder='Search by name'
                  onChange={e => this.setState({searchText: e.target.value})}
                  onKeyPress={e => { if (e.key === 'Enter') { this.onSearch(); }}} />
                <span className='input-group-btn'>
                  <button
                    style={{ padding: '4px 10px', fontSize: 16, backgroundColor: '#ececec', border: '0.5px solid #d8d8d8', height: 40 }}
                    onClick={this.onSearch.bind(this)}
                    className='btn btn-secondary'>
                    <span className='fa fa-search' aria-hidden='true' />
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div style={{ marginBottom: '30px', width: '400px', top: '-25px', position: 'relative', left: '-20px' }} className='stepper'>
            <Stepper steps={steps} activeStep={currentStep} disabledSteps={[1]} />
          </div>
        </div>
        <div className='row'>
          {this.renderItemList()}
        </div>
      </React.Fragment>
    );
  }
  //#endregion Render
}

const mapStateToProps = (state) => {
  return {
    itemArray: state.ProjectStore.InventoryTemplateList
  };
};

export default connect(mapStateToProps)(ImportInventory);



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/inventory-import.js